// extracted by mini-css-extract-plugin
export default {"link-text-color":"hawk-seasonal-link-item-link-text-color","linkTextColor":"hawk-seasonal-link-item-link-text-color"};